import get from 'lodash/get';
import set from 'lodash/set';

let cancelTokens = {};

export default function cancelVault(id, vault = cancelTokens) {

    return {
        isMockup: false,
        id: () => id,

        set: (foo) => {
            // console.log('setting cancel ', id);
            set(vault, id, foo);
        },

        cancel: (msg) => {
            // console.log('cancelling', id);
            get(vault, id, () => {})(msg);
        },

        reset: () => {
            delete vault[id];
        }
    }
}

export const mockupCancel = { isMockup: true, set: () => {}, cancel: () => {}, reset: () => {}};